import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';
import {
  MutationSigninWithOtpArgs,
  SigninOutput,
} from '@updater/consumer-graph/generated/graphql';

const SIGNIN_WITH_OTP = gql`
  mutation SigninWithOtp($input: SigninWithOtpInput!) {
    signinWithOtp(input: $input) {
      mover {
        id
        uuid
      }
      session {
        accessToken
        client
        uid
      }
    }
  }
`;

export function useSigninWithOtp() {
  const [error, setError] = useState<string | null>(null);

  const [signinWithOtp] = useMutation<
    { signinWithOtp: SigninOutput },
    MutationSigninWithOtpArgs
  >(SIGNIN_WITH_OTP);

  const signin = async (email: string, otpCode: string) => {
    setError(null);
    try {
      const result = await signinWithOtp({
        variables: { input: { email, otpCode } },
      });
      if (result.errors?.length) {
        setError(result.errors[0].message);
        return null;
      }
      const { mover, session } = result.data?.signinWithOtp ?? {};
      if (!mover || !session) {
        setError('Verification failed. Please check your code and try again.');
        return null;
      }
      return { mover, session };
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'Something went wrong. Please try again.'
      );
      return null;
    }
  };

  return { signin, error, clearError: () => setError(null) };
}
